import { IconType } from '@kinomap-dev/ng-ui-lib/core';

export type FilterType = RangeFilterType | CheckboxFilterType | RadioFilterType | SearchFilterType;
export type FilterTypeName = FilterType['type'];
export type FilterSortDirection = 'asc' | 'desc';
export type ActiveSort = {
  sortType: string;
  sortDirection: FilterSortDirection;
};

export type FilterSortMode = 'alphabetic' | 'numeric';

export type FilterMenuConfig = {
  filters: FilterType[];
  sortable?: boolean;
  sortMode?: FilterSortMode;
};

export type BaseFilterType = {
  unit?: string;
  activeKey?: string;
};

export type RangeFilterType = {
  type: 'range';
  min?: number;
  max?: number;
} & BaseFilterType;

export type SearchFilterType = {
  type: 'search';
  value?: number | string;
} & BaseFilterType;

export type CheckboxValueType = {
  label: string;
  value: string;
  icon?: IconType;
  iconUrl?: string;
  isActive?: boolean;
};

export type CheckboxFilterType = {
  type: 'checkbox';
  data: CheckboxValueType[];
} & BaseFilterType;

export type RadioFilterType = {
  type: 'radio';
  data: CheckboxValueType[];
} & BaseFilterType;

export type ActiveObjectFilter = Partial<
  Pick<RangeFilterType, 'min' | 'max'> & Pick<SearchFilterType, 'value'>
>;
export type ActiveFilterValue = ActiveObjectFilter | string[];
export type ActiveFilters = Record<string, ActiveFilterValue>;

export type GetActiveFiltersOptions = {
  defaultFilters?: Record<string, FilterMenuConfig>;
  tableHeaderElements?: string[];
};

export type ActiveFilterHttpParamNameMap = Record<string, string | Record<string, string>>;
export type ActiveFilterHttpValueTransformMap = Record<
  string,
  (value: string | number, valueKey?: string) => string | number
>;
export type ActiveSortHttpParamNameMap = {
  sortType: string;
  sortDirection: string;
};
export type ActiveFilterHttpParam = {
  name: string;
  value: string | number;
};

export const ACTIVE_SORT_HTTP_PARAM_NAMES: ActiveSortHttpParamNameMap = {
  sortType: 'sortType',
  sortDirection: 'sortDirection',
};

export type FilterHandler<TFilter extends FilterType> = {
  isEqual: (filter: TFilter, defaultFilter: TFilter) => boolean;
  toActiveValue: (filter: TFilter) => ActiveFilterValue | undefined;
};
